import React from "react";
import { useFormik } from "formik";
import "primeflex/primeflex.css";
import ProInputText from "../common/ProInputText";
import ProFormFooter from "../common/ProFormFooter";
import useSetup from "../../hooks/useSetup";

import _ from "lodash";
import { SearchTree, GetNode, ValidateCharacters, ExceedsBedLimit } from "../../constants/ProConstants";
import { Confirm } from "../../utilities/ProDialogs";
import { useHierarchyService } from "../../hooks/useHierarchyService";

const ProDuplicateForm = ({
    showFooter = false,
    closeSideBar = () => console.log("close"), formModel = {}, formAction
}) => {
    const {data:{activeTree}} = useHierarchyService()
    const { actions:{DuplicateNode}} = useSetup({refreshTree:false});

    const formik = useFormik({
        initialValues: {
            type: _.isEmpty(formModel) ? {} : formModel.type,
            model: {
                ...formModel.model,
                name: 'Copy Of ' + _.get(formModel, 'model.name'),

            }
        },
        validate: (data) => {
            let errors = {};
            if (_.isEmpty(data.model.name)) {
                errors.name = `${data.type.name} is required.`;
            }
            if (!_.isEmpty(data.model.name) && data.model.name.length > 120) {              
                errors.name = "Max 120 characters allowed";
            } 
            if (!_.isEmpty(data.model.name) && !ValidateCharacters(data.model.name)) {              
                errors.name = "Invalid Characters";
            } 
            var element;
            switch (data.type.code) {
                case 'BUILDING':
                    element = SearchTree(activeTree, "label", `${_.trimStart(_.trimEnd(data.model.name))}`);
                    if (!_.isNull(element)) {
                        errors.name = `${data.type.name} name already exists!`;
                    }
                    break;
                case 'FLOOR':
                case 'WING':
                case 'UNIT':
                case 'ROOM':
                    if (_.get(data.model.building, "name")) {
                        element = SearchTree(SearchTree(activeTree, "label", (_.isEqual(data.model.parentType.code, "BUILDING") || _.isEmpty(data.model.parent)) ? data.model.building.name : data.model.parent.name), "label", `${_.trimStart(_.trimEnd(data.model.name))}`);
                        if (!_.isNull(element))
                            errors.name = `${data.type.name} name already exists!`;
                    }
                    break;
                case 'BED':
                    if (_.get(data.model.building, "name")) {
                        element = SearchTree(SearchTree(activeTree, "label", data.model.building.name), "label", `${_.trimStart(_.trimEnd(data.model.name))}`);
                        if (!_.isNull(element))
                            errors.name = `${data.type.name} name already exists!`;
                    }
                    break;
                default:
                    break;
            }

            return errors;
        },
        onSubmit: (data) => {
            handleSubmit(data);
        },
    });





    const handleSubmit = (data) => {
        if(data.type.code === "BED" && ExceedsBedLimit(activeTree, data.model)){         
                Confirm(() => { DuplicateNode(GetNode(data), {id: data.model.id, name:_.trimStart(_.trimEnd(data.model.name)), type: data.type.code});  },
                        () => { console.log("Duplicate not confirmed"); },
                        "Adding will exceed bed capacity. ")
        } 
        else {       
            DuplicateNode(GetNode(data), {id: data.model.id, name:_.trimStart(_.trimEnd(data.model.name)), type: data.type.code});
            closeSideBar();
        }
    };

    return (
        <form onSubmit={formik.handleSubmit}>
            <ProInputText
                headerText="Name"
                id="name"
                labelText="Name"
                value={formik.values.model.name}
                onChange={(e) => {
                    formik.setValues({ ...formik.values, model: { ...formik.values.model, name: e.target.value } });
                }}
                formik={formik}
                name="name"
                error="name"
                required
            />
            {showFooter && (<ProFormFooter onSave={() => console.log("Save")} onCancel={closeSideBar} />)}
        </form>
    );
};

export default ProDuplicateForm;
